export default {
      id: "oc-res-servertemplate-container-usage",
      viewBox: "0 0 1027 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-servertemplate-container",
      toString: function () {
        return this.url;
      }
    }